import { createRouter, createWebHistory } from 'vue-router';
import orgSettingRouter from './config/orgSetting';
import errorRouter from './config/error';

export { injectRouter } from './interceptor';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...orgSettingRouter, ...errorRouter]
});

export default router;
